export default __webpack_public_path__ + "static/media/slide_2.acb835f5.jpg";